export default __webpack_public_path__ + "static/media/img-0420-belarus-full-face.c17817a8.png";